import type { ReactNode } from "react";
import { MicroLabel } from "./Text";

/**
 * A section folded away by default, for facts some readers need and most do not.
 *
 * A native `<details>`: keyboard operable, announced as expandable, and open in
 * the browser's find-in-page without any script. The closed summary carries a
 * line of its own (`summary`) so the reader can tell whether opening it is worth
 * a click without opening it.
 */
export function Disclosure({
  label,
  summary,
  children,
}: {
  readonly label: string;
  readonly summary?: ReactNode;
  readonly children: ReactNode;
}) {
  return (
    <details className="group border-t border-rule pt-3">
      <summary className="flex cursor-pointer list-none flex-wrap items-baseline justify-between gap-x-4 gap-y-1 [&::-webkit-details-marker]:hidden">
        <span className="flex items-baseline gap-2">
          <span
            aria-hidden="true"
            className="inline-block text-ink-faint transition-transform duration-fast ease-swiss group-open:rotate-90"
          >
            ▸
          </span>
          <MicroLabel>{label}</MicroLabel>
        </span>
        {summary === undefined ? null : (
          <span className="text-data tabular-nums text-ink-faint">{summary}</span>
        )}
      </summary>
      <div className="flex flex-col gap-6 pt-5">{children}</div>
    </details>
  );
}
